import React from 'react';
import { Image as RNImage } from 'expo-image';

import { Box } from 'app/shopify/theme';

export type ImageAspectRatio = '1:1' | '2:3' | '7:5' | '16:9';
export type ImageOrientation = 'landscape' | 'portrait';

export interface ImageProps {
  aspectRatio?: ImageAspectRatio;
  orientation?: ImageOrientation;
  imageUri?: string;
  width?: number;
  height?: number;
  borderRadius?: number;
}

const IMAGE_TEMP_ASSET = 'https://www.figma.com/api/mcp/asset/ccf4f0ef-f21f-448f-a69a-7c60a0310d4a';

const LANDSCAPE_DIMENSIONS_BY_RATIO: Record<ImageAspectRatio, { width: number; height: number }> = {
  '1:1': { width: 200, height: 200 },
  '2:3': { width: 200, height: 300 },
  '7:5': { width: 280, height: 200 },
  '16:9': { width: 380, height: 180 },
};

function getDimensions(aspectRatio: ImageAspectRatio, orientation: ImageOrientation) {
  const base = LANDSCAPE_DIMENSIONS_BY_RATIO[aspectRatio];

  if (aspectRatio === '2:3') {
    return base;
  }

  if (orientation === 'portrait') {
    return { width: base.height, height: base.width };
  }

  return base;
}

export function Image({
  aspectRatio = '1:1',
  orientation = 'landscape',
  imageUri = IMAGE_TEMP_ASSET,
  width,
  height,
  borderRadius = 0,
}: ImageProps) {
  const resolvedDimensions = getDimensions(aspectRatio, orientation);
  const resolvedWidth = width ?? resolvedDimensions.width;
  const resolvedHeight = height ?? resolvedDimensions.height;

  return (
    <Box width={resolvedWidth} height={resolvedHeight} style={{ overflow: 'hidden', borderRadius }}>
      <RNImage source={{ uri: imageUri }} style={{ width: '100%', height: '100%', borderRadius }} contentFit="cover" />
    </Box>
  );
}
